export default "__VITE_ASSET__H5G0cTj___"